import type { SupportContent } from "./types";

export const supportZh: SupportContent = {
  locale: "zh",
  seo: {
    title: "支持 - Prismark",
    description: "Prismark 支持页面，包含使用说明、常见问题、联系邮箱及隐私政策链接。"
  },
  nav: {
    home: "Prismark",
    support: "支持",
    privacy: "隐私政策"
  },
  hero: {
    eyebrow: "Prismark 支持",
    title: "有什么可以帮你？",
    description: "在这里可以了解 Prismark 的常见问题，包括相机权限、相册访问、双摄录制支持以及联系方式。"
  },
  guide: {
    title: "支持说明",
    body: [
      "Prismark 是一款面向 iOS 的轻量而专业的相机应用，提供手动参数控制与多种拍摄辅助工具。",
      "如果你在使用过程中遇到问题，可以先查看下方常见问题。需要进一步帮助时，请通过邮箱联系我们，并尽量附上设备型号、iOS 版本、App 版本以及问题描述。"
    ]
  },
  faq: {
    title: "常见问题",
    items: [
      {
        question: "为什么 Prismark 需要相机权限？",
        answer: "Prismark 需要相机权限来进行拍照、视频录制，以及在支持的设备上使用双摄录制等相机相关功能。"
      },
      {
        question: "为什么 Prismark 需要麦克风权限？",
        answer: "当你录制带声音的视频时，需要使用麦克风权限。Prismark 不会在非录制视频的情况下使用麦克风。"
      },
      {
        question: "为什么 Prismark 需要相册权限？",
        answer: "相册权限用于保存你拍摄的照片和视频，也用于在需要时让你在 App 内查看已拍摄的媒体内容。"
      },
      {
        question: "Prismark 会上传我的照片或视频吗？",
        answer:
          "Prismark 的核心拍摄流程设计为在设备本地处理照片和视频。当前版本不会将你的照片或视频上传到我们的服务器。"
      },
      {
        question: "Prismark 会收集个人信息吗？",
        answer: "Prismark 的核心相机功能不需要注册账号。关于数据处理的最新说明，请查看隐私政策。"
      },
      {
        question: "为什么我的设备无法使用双摄录制？",
        answer: "有两种可能。双摄录制属于 Prismark Pro，是一次性内购，未解锁时会先提示你购买。另外它也依赖设备硬件和 iOS 系统支持，部分设备型号或摄像头组合无法同时用两颗摄像头录制。"
      },
      {
        question: "Prismark Pro 包含哪些功能？是订阅吗？",
        answer: "Prismark Pro 解锁三项功能：导入你自己的 LUT、ProRAW 与 RAW 输出、双摄画中画录制。Prismark 的其他功能都不额外收费。这是一次性买断而非订阅，没有周期扣款，也不需要取消。"
      },
      {
        question: "怎么导入 LUT？支持哪些文件？",
        answer: "LUT 导入属于 Prismark Pro。解锁后可以在「设置 > LUTs > 导入 LUT」导入，也可以点取景器滤镜条末尾的「+」。Prismark 支持 .cube 文件和 Hald PNG 图片，也可以在「文件」App 里用「打开方式」把 .cube 发给 Prismark。导入后的 LUT 会排在内置滤镜旁边，强度调节方式完全一样；在「设置 > LUTs」里可以重命名、拖动排序或删除。Prismark 本身不附带任何 LUT，所以在你导入之前列表是空的。"
      },
      {
        question: "我买了 Prismark Pro，却找不到 ProRAW，为什么？",
        answer: "ProRAW 除了需要购买，还取决于你的设备。Apple 只在部分 iPhone 机型上支持 ProRAW；在不支持的设备上，Prismark 会直接隐藏这一组，而不是放一个点了也用不了的选项，所以「设置 > 照片规格」里不会出现它。LUT 导入和双摄录制是独立的，不受影响。如果你的设备确实支持 ProRAW 却仍然找不到，请邮件联系我们并附上设备型号。"
      },
      {
        question: "我买了 Prismark Pro，换了新设备却显示未解锁，怎么办？",
        answer: "打开 Prismark 的设置页，点顶部的 Prismark Pro 入口，选择「恢复购买」。请确认这台设备登录的是当初购买时用的那个 Apple 账户。如果仍然没有解锁，请邮件联系我们，附上 Apple 账户所在地区和大致的购买日期。"
      },
      {
        question: "为什么录制质量或性能会有差异？",
        answer: "相机性能可能受到设备型号、iOS 版本、剩余存储空间、电量、机身温度以及所选拍摄模式影响。"
      },
      {
        question: "如何反馈问题或提出功能建议？",
        answer: "请通过邮箱联系我们，并尽量附上设备型号、iOS 版本、App 版本、复现步骤，以及截图或录屏等辅助信息。"
      }
    ]
  },
  contact: {
    title: "联系我们",
    description: "如果你需要支持、反馈问题、提出建议，或有隐私相关问题，可以通过邮箱联系我们。",
    emailLabel: "邮箱",
    email: "axqora@gmail.com",
    emailSubject: "Prismark 支持请求"
  },
  relatedLinks: {
    title: "相关链接",
    links: [
      { label: "隐私政策", href: "/zh/privacy" },
      { label: "用户协议", href: "/zh/terms" }
    ]
  }
};
